import { Col, List, Row } from "antd";
import React from "react";
import { TextComponent } from "../../../../../components";
import styles from "./documents.module.css";

import pdfIcon from "../../../../../assets/staticImages/pdfIcon.png";
import DocIcon from "../../../../../assets/staticImages/DocIcon.png";
import PngIcons from "../../../../../assets/staticImages/PngIcons.png";

const icon1 = (
  <svg
    className={styles.image}
    viewBox="0 0 64 74"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.91825 69.5086L0.328125 62.7031H6.91825V69.5086Z"
      className={styles.fileIcon}
    />
    <path
      d="M56.9141 69.5086L63.5035 62.7031H56.9141V69.5086Z"
      className={styles.fileIcon}
    />
    <path
      d="M56.9126 10.9803H46.3984V0.103516L56.9126 10.9803Z"
      fill="#B1B1B1"
    />
    <path
      d="M46.4501 0.0917969H9.01281C7.85794 0.0917969 6.92188 1.06226 6.92188 2.25909V71.609C6.92188 72.8058 7.85794 73.7763 9.01281 73.7763H54.8257C55.9806 73.7763 56.9167 72.8058 56.9167 71.609V10.9282H46.3912L46.4501 0.0917969Z"
      fill="#F0F0F0"
    />
    <path
      d="M63.4913 62.7033H0.328125V39.5641C0.328125 38.8125 0.917131 38.2031 1.64364 38.2031H62.1751C62.9016 38.2031 63.4906 38.8125 63.4906 39.5641V62.7033H63.4913Z"
      className={styles.fileIcon}
    />
    <path
      d="M24.4756 53.2176C24.0241 54.0622 23.3749 54.7208 22.5288 55.1927C21.6813 55.6653 20.6851 55.9012 19.5388 55.9012H15.4766V44.7734H19.5388C20.695 44.7734 21.6938 45.0046 22.5354 45.4662C23.3776 45.9279 24.0241 46.5789 24.4756 47.4181C24.9264 48.2572 25.1525 49.2222 25.1525 50.3137C25.1525 51.4052 24.9264 52.3737 24.4756 53.2176ZM21.676 52.6595C22.2392 52.1035 22.5208 51.3218 22.5208 50.3144C22.5208 49.307 22.2392 48.5253 21.676 47.9693C21.1134 47.414 20.3248 47.135 19.3107 47.135H18.0785V53.4939H19.3107C20.3248 53.4932 21.1128 53.2155 21.676 52.6595Z"
      fill="white"
    />
    <path
      d="M34.5037 45.3314C35.3307 45.819 35.9819 46.4961 36.4591 47.3619C36.9351 48.227 37.1744 49.2064 37.1744 50.2965C37.1744 51.3887 36.9331 52.3694 36.4519 53.24C35.97 54.1107 35.3155 54.7898 34.4892 55.2781C33.6622 55.7657 32.7473 56.0099 31.7431 56.0099C30.739 56.0099 29.8234 55.7657 28.9977 55.2781C28.1707 54.7898 27.5163 54.1107 27.035 53.24C26.5531 52.3694 26.3125 51.3887 26.3125 50.2965C26.3125 49.2057 26.5531 48.227 27.035 47.3619C27.5163 46.4961 28.1707 45.8197 28.9977 45.3314C29.8241 44.8438 30.7396 44.5996 31.7431 44.5996C32.7572 44.5996 33.6781 44.8431 34.5037 45.3314ZM29.7123 47.9596C29.2099 48.5314 28.9594 49.311 28.9594 50.2965C28.9594 51.2731 29.2099 52.0494 29.7123 52.6259C30.2141 53.2031 30.891 53.4917 31.7431 53.4917C32.5853 53.4917 33.2589 53.2031 33.7666 52.6259C34.2737 52.0494 34.5275 51.2725 34.5275 50.2965C34.5275 49.3206 34.2763 48.5444 33.7746 47.9671C33.2722 47.3899 32.5952 47.102 31.7431 47.102C30.891 47.102 30.2141 47.3872 29.7123 47.9596Z"
      fill="white"
    />
    <path
      d="M46.946 45.7783C47.8437 46.5231 48.4241 47.5312 48.6879 48.8005H45.9339C45.7309 48.2862 45.4196 47.882 44.9985 47.5879C44.5774 47.2939 44.0776 47.1475 43.4999 47.1475C42.739 47.1475 42.1255 47.4361 41.6595 48.0133C41.1927 48.5899 40.9601 49.3613 40.9601 50.327C40.9601 51.292 41.1934 52.0607 41.6595 52.6324C42.1262 53.2048 42.7396 53.4907 43.4999 53.4907C44.0783 53.4907 44.578 53.3437 44.9985 53.0503C45.4196 52.7562 45.7309 52.3575 45.9339 51.8541H48.6879C48.4241 53.1132 47.843 54.1179 46.946 54.8681C46.0482 55.6183 44.9152 55.9931 43.5455 55.9931C42.501 55.9931 41.5828 55.7544 40.7921 55.2771C40.0015 54.799 39.39 54.1309 38.959 53.2698C38.528 52.4102 38.3125 51.4281 38.3125 50.327C38.3125 49.2252 38.528 48.2438 38.959 47.3835C39.39 46.5238 40.0015 45.8543 40.7921 45.3769C41.5828 44.8995 42.501 44.6602 43.5455 44.6602C44.9152 44.6602 46.0482 45.0329 46.946 45.7783Z"
      fill="white"
    />
    <path
      d="M38.6214 11.6617H13.4859C13.1223 11.6617 12.8281 11.3574 12.8281 10.9813C12.8281 10.6051 13.1223 10.3008 13.4859 10.3008H38.6214C38.985 10.3008 39.2792 10.6051 39.2792 10.9813C39.2792 11.3574 38.985 11.6617 38.6214 11.6617Z"
      className={styles.fileIcon}
    />
    <path
      d="M50.9131 20.6539H35.6968C35.3332 20.6539 35.0391 20.3496 35.0391 19.9735C35.0391 19.5973 35.3332 19.293 35.6968 19.293H50.9138C51.2774 19.293 51.5716 19.5973 51.5716 19.9735C51.5709 20.3496 51.2767 20.6539 50.9131 20.6539Z"
      className={styles.fileIcon}
    />
    <path
      d="M30.9267 20.6539H13.4859C13.1223 20.6539 12.8281 20.3496 12.8281 19.9735C12.8281 19.5973 13.1223 19.293 13.4859 19.293H30.9267C31.2903 19.293 31.5844 19.5973 31.5844 19.9735C31.5844 20.3496 31.2903 20.6539 30.9267 20.6539Z"
      className={styles.fileIcon}
    />
    <path
      d="M50.9165 29.6481H46.0015C45.6379 29.6481 45.3438 29.3437 45.3438 28.9676C45.3438 28.5914 45.6379 28.2871 46.0015 28.2871H50.9165C51.2801 28.2871 51.5743 28.5914 51.5743 28.9676C51.5743 29.3431 51.2801 29.6481 50.9165 29.6481Z"
      className={styles.fileIcon}
    />
    <path
      d="M39.732 29.6481H13.4859C13.1223 29.6481 12.8281 29.3437 12.8281 28.9676C12.8281 28.5914 13.1223 28.2871 13.4859 28.2871H39.732C40.0956 28.2871 40.3898 28.5914 40.3898 28.9676C40.3898 29.3431 40.0956 29.6481 39.732 29.6481Z"
      className={styles.fileIcon}
    />
  </svg>
);

const icon2 = (
  <svg
    className={styles.image}
    viewBox="0 0 74 84"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M73.655 68.8911V46.0323C73.655 43.5238 71.6824 41.4823 69.257 41.4823H67.0768V17.3959C67.0768 16.3393 66.5797 15.4023 65.8148 14.8224L56.0357 4.70539C55.9392 4.56656 55.8321 4.43456 55.7138 4.31146C55.1354 3.70963 54.3487 3.37109 53.5283 3.37109H16.0911C13.2386 3.37109 10.9183 5.77365 10.9183 8.72674V41.4816H8.72617C6.30139 41.4816 4.32812 43.5224 4.32812 46.0316V69.1701C4.32812 70.0168 4.65337 70.8286 5.23246 71.427L10.9176 77.2983V78.0766C10.9176 81.0297 13.2379 83.4323 16.0904 83.4323H61.9033C64.7558 83.4323 67.0761 81.0297 67.0761 78.0766V77.2983L72.7467 71.4421C73.3146 70.8635 73.6663 70.0599 73.6663 69.1701C73.6669 69.0764 73.6629 68.9834 73.655 68.8911Z"
      fill="#DCDCDC"
    />
    <path
      d="M70.1863 66.4223V43.5629C70.1863 41.0543 68.2137 39.0129 65.7882 39.0129H63.608V14.9272C63.608 13.8705 63.1109 12.9336 62.3461 12.3536L52.5663 2.23596C52.4698 2.09712 52.3627 1.96513 52.2444 1.84203C51.6666 1.24088 50.8799 0.902344 50.0596 0.902344H12.6223C9.76983 0.902344 7.4495 3.3049 7.4495 6.25799V39.0129H5.25742C2.83198 39.0135 0.859375 41.0543 0.859375 43.5629V66.7014C0.859375 67.548 1.18462 68.3598 1.76371 68.9583L7.44884 74.8296V75.6079C7.44884 78.561 9.76917 80.9635 12.6216 80.9635H58.4346C61.287 80.9635 63.6074 78.561 63.6074 75.6079V74.8296L69.278 68.9733C69.8458 68.3947 70.1975 67.5911 70.1975 66.7014C70.1982 66.6077 70.1942 66.5147 70.1863 66.4223Z"
      fill="white"
    />
    <path
      d="M10.5276 73.5067L3.9375 66.7012H10.5276V73.5067Z"
      className={styles.fileIcon}
    />
    <path
      d="M60.5234 73.5067L67.1129 66.7012H60.5234V73.5067Z"
      className={styles.fileIcon}
    />
    <path d="M60.522 14.9803H50.0078V4.10352L60.522 14.9803Z" fill="#B1B1B1" />
    <path
      d="M50.0594 4.08984H12.6222C11.4673 4.08984 10.5312 5.0603 10.5312 6.25713V75.607C10.5312 76.8038 11.4673 77.7743 12.6222 77.7743H58.4351C59.59 77.7743 60.526 76.8038 60.526 75.607V14.9263H50.0006L50.0594 4.08984Z"
      fill="#F0F0F0"
    />
    <path
      d="M67.1006 66.7033H3.9375V43.5641C3.9375 42.8125 4.52651 42.2031 5.25301 42.2031H65.7845C66.511 42.2031 67.1 42.8125 67.1 43.5641V66.7033H67.1006Z"
      className={styles.fileIcon}
    />
    <path
      d="M22.8285 56.0874V59.9911H20.2266V48.8633H24.4408C25.7187 48.8633 26.6924 49.1916 27.3621 49.8467C28.0317 50.5026 28.3662 51.3869 28.3662 52.4989C28.3662 53.1917 28.2168 53.8072 27.9174 54.3475C27.6179 54.8878 27.175 55.3132 26.586 55.6223C25.9976 55.9321 25.2824 56.0867 24.4408 56.0867H22.8285V56.0874ZM25.7187 52.4996C25.7187 51.523 25.1964 51.0354 24.1519 51.0354H22.8285V53.9317H24.1519C25.1964 53.9317 25.7187 53.4536 25.7187 52.4996Z"
      fill="white"
    />
    <path
      d="M39.195 59.9911H36.5937L32.2426 53.1602V59.9911H29.6406V48.8633H32.2426L36.5937 55.757V48.8633H39.195V59.9911Z"
      fill="white"
    />
    <path
      d="M49.3582 49.7771C50.2308 50.459 50.7729 51.3822 50.9858 52.5469H48.2324C48.0493 52.1482 47.7704 51.8302 47.3955 51.5943C47.0201 51.3583 46.5685 51.24 46.0417 51.24C45.22 51.24 44.5602 51.5259 44.0638 52.0983C43.5667 52.67 43.3188 53.4435 43.3188 54.4195C43.3188 55.4795 43.5799 56.292 44.1021 56.8583C44.6244 57.4252 45.3667 57.7083 46.3306 57.7083C46.9493 57.7083 47.4921 57.5326 47.9581 57.1811C48.4248 56.8295 48.7547 56.3282 48.9477 55.6778H45.6609V53.7417H51.1226V56.4021C50.9197 57.0525 50.5951 57.6557 50.1495 58.2117C49.7033 58.7677 49.1328 59.2191 48.4374 59.5658C47.7433 59.9119 46.9487 60.0849 46.0569 60.0849C44.9721 60.0849 44.0235 59.8462 43.2123 59.3689C42.4006 58.8908 41.7745 58.2226 41.3336 57.3616C40.892 56.5019 40.6719 55.5199 40.6719 54.4188C40.6719 53.317 40.892 52.3356 41.3336 51.4753C41.7752 50.6156 42.3986 49.946 43.2051 49.4687C44.0116 48.9913 44.9516 48.752 46.0271 48.752C47.375 48.754 48.4856 49.0953 49.3582 49.7771Z"
      fill="white"
    />
    <path
      d="M35.9017 36.0893H16.3607C16.0963 36.0893 15.857 35.9251 15.7545 35.6728C15.652 35.4204 15.7056 35.1291 15.8907 34.9328L25.6612 24.5949C25.9077 24.333 26.3553 24.333 26.6019 24.5949L36.3724 34.9328C36.5574 35.1291 36.6117 35.4197 36.5085 35.6728C36.4054 35.9251 36.1661 36.0893 35.9017 36.0893ZM17.9241 34.7283H34.3389L26.1312 26.0448L17.9241 34.7283Z"
      className={styles.fileIcon}
    />
    <path
      d="M54.5927 36.092H35.9018C35.7247 36.092 35.5548 36.0182 35.4318 35.8875L31.2109 31.4217C30.9604 31.1563 30.9611 30.733 31.2123 30.4683L40.6998 20.4785C40.8241 20.3472 41.0019 20.2891 41.1725 20.2754C41.3496 20.2768 41.5202 20.352 41.6425 20.4847L55.066 34.9403C55.2491 35.1373 55.3007 35.4273 55.1969 35.6783C55.0944 35.9293 54.8558 36.092 54.5927 36.092ZM36.1788 34.7311H53.0485L41.1639 21.9325L32.6025 30.947L36.1788 34.7311Z"
      className={styles.fileIcon}
    />
    <path
      d="M26.9928 20.5678C24.9587 20.5678 23.3047 18.8567 23.3047 16.753C23.3047 14.6486 24.9587 12.9375 26.9928 12.9375C29.0262 12.9375 30.6802 14.6486 30.6802 16.753C30.6802 18.856 29.0262 20.5678 26.9928 20.5678ZM26.9928 14.2985C25.6845 14.2985 24.6202 15.3996 24.6202 16.753C24.6202 18.1064 25.6845 19.2068 26.9928 19.2068C28.301 19.2068 29.3646 18.1064 29.3646 16.753C29.3646 15.3996 28.301 14.2985 26.9928 14.2985Z"
      className={styles.fileIcon}
    />
  </svg>
);

const icon3 = (
  <svg
    className={styles.image}
    viewBox="0 0 74 83"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M73.655 45.2082C73.655 42.7115 71.6824 40.6797 69.2569 40.6797H67.0768V16.7076C67.0768 15.656 66.5796 14.7235 65.8148 14.1463L56.0357 4.07729C55.9399 3.93911 55.8321 3.80774 55.7144 3.68591C55.136 3.08693 54.3493 2.75 53.529 2.75H16.0911C13.2386 2.75 10.9182 5.14116 10.9182 8.08024V40.6804H8.72617C6.30139 40.6804 4.32812 42.7115 4.32812 45.2088V68.2376C4.32812 69.0802 4.65337 69.8882 5.23246 70.4837L10.9176 76.3272V77.1018C10.9176 80.0409 13.2379 82.432 16.0904 82.432H61.9033C64.7558 82.432 67.0761 80.0409 67.0761 77.1018V76.3272L72.7612 70.4837C73.4177 69.8092 73.7317 68.8815 73.6543 67.9626V45.2082H73.655Z"
      fill="#DCDCDC"
    />
    <path
      d="M70.1862 42.7492C70.1862 40.2525 68.2136 38.2207 65.7882 38.2207H63.608V14.2493C63.608 13.1977 63.1109 12.2652 62.346 11.688L52.567 1.6183C52.4711 1.48013 52.3634 1.34876 52.2457 1.22692C51.6666 0.627942 50.8799 0.291016 50.0596 0.291016H12.6223C9.76983 0.291016 7.4495 2.68217 7.4495 5.62126V38.2214H5.25742C2.83198 38.2214 0.859375 40.2525 0.859375 42.7492V65.7779C0.859375 66.6205 1.18462 67.4285 1.76371 68.0241L7.44884 73.8675V74.6421C7.44884 77.5812 9.76916 79.9724 12.6216 79.9724H58.4345C61.287 79.9724 63.6074 77.5812 63.6074 74.6421V73.8675L69.2925 68.0241C69.9489 67.3495 70.2629 66.4218 70.1856 65.5029V42.7492H70.1862Z"
      fill="white"
    />
    <path
      d="M10.5276 72.5525L3.9375 65.7793H10.5276V72.5525Z"
      className={styles.fileIcon}
    />
    <path
      d="M60.5234 72.5525L67.1129 65.7793H60.5234V72.5525Z"
      className={styles.fileIcon}
    />
    <path d="M60.522 14.3018H50.0078V3.47656L60.522 14.3018Z" fill="#B1B1B1" />
    <path
      d="M50.0594 3.46289H12.6222C11.4673 3.46289 10.5312 4.42875 10.5312 5.6199V74.6407C10.5312 75.8319 11.4673 76.7978 12.6222 76.7978H58.4351C59.59 76.7978 60.526 75.8319 60.526 74.6407V14.2479H50.0006L50.0594 3.46289Z"
      fill="#F0F0F0"
    />
    <path
      d="M67.1006 65.7785H3.9375V42.749C3.9375 42.001 4.52651 41.3945 5.25301 41.3945H65.7845C66.511 41.3945 67.1 42.001 67.1 42.749V65.7785H67.1006Z"
      className={styles.fileIcon}
    />
    <path
      d="M24.5629 55.1156V59.0001H21.9609V47.9258H26.1752C27.453 47.9258 28.4268 48.2525 29.0964 48.9046C29.7661 49.5573 30.1006 50.4374 30.1006 51.5442C30.1006 52.2337 29.9512 52.8463 29.6517 53.384C29.3523 53.9217 28.9094 54.3451 28.3204 54.6527C27.732 54.9611 27.0167 55.1149 26.1752 55.1149H24.5629V55.1156ZM27.453 51.5448C27.453 50.5729 26.9308 50.0876 25.8863 50.0876H24.5629V52.9701H25.8863C26.9308 52.9701 27.453 52.4944 27.453 51.5448Z"
      fill="white"
    />
    <path
      d="M40.374 56.3299C39.9225 57.1705 39.2734 57.826 38.4272 58.2956C37.5797 58.766 36.5835 59.0008 35.4372 59.0008H31.375V47.9258H35.4372C36.5934 47.9258 37.5923 48.1558 38.4338 48.6153C39.276 49.0747 39.9225 49.7227 40.374 50.5579C40.8249 51.3931 41.051 52.3535 41.051 53.4398C41.0516 54.5261 40.8255 55.4899 40.374 56.3299ZM37.5744 55.7738C38.1377 55.2204 38.4193 54.4424 38.4193 53.4398C38.4193 52.4372 38.1377 51.6592 37.5744 51.1058C37.0119 50.5531 36.2232 50.2754 35.2092 50.2754H33.9769V56.6042H35.2092C36.2239 56.6042 37.0119 56.3278 37.5744 55.7738Z"
      fill="white"
    />
    <path
      d="M49.5445 47.9258V50.0562H45.1332V52.4835H48.5403V54.52H45.1332V59.0001H42.5312V47.9258H49.5445Z"
      fill="white"
    />
    <path
      d="M25.3924 37.1112C24.4623 37.1112 23.7523 36.7314 23.2968 36.1957C22.3184 35.0447 22.5055 33.2158 23.741 31.8477C24.7716 30.7076 27.8046 29.4592 31.2937 28.3926C32.2271 25.8626 33.1347 22.9535 33.8956 20.3663C32.9933 18.114 32.3818 15.5262 32.2443 12.5959C32.1147 9.84197 33.4507 8.27645 34.8376 8.15393C35.9118 8.05932 37.1262 8.86046 37.3688 10.8725C37.4832 11.8206 37.3854 12.8498 37.0799 13.9314L36.6516 15.4758C36.2113 17.0685 35.7605 18.6749 35.3004 20.2513C36.3739 22.7554 37.8296 24.8069 39.3573 26.4031C41.4661 26.0035 43.3032 25.7673 44.3853 25.7748C47.3667 25.7918 48.4879 27.1014 48.8898 27.8808C49.3572 28.7854 49.3122 29.867 48.7715 30.7028C48.197 31.5924 47.1757 32.0594 46.0248 31.9477C44.3761 31.7891 41.56 30.4421 38.8985 27.859C36.795 28.2831 34.4562 28.8589 32.2839 29.4994C31.0861 32.6284 29.8942 34.9583 28.775 35.7744C27.4522 36.7382 26.3139 37.1112 25.3924 37.1112ZM30.6782 29.9936C27.8191 30.9172 25.4724 31.9212 24.7049 32.7706C23.8349 33.7331 23.8362 34.7738 24.2864 35.3041C24.7921 35.8983 26.07 36.0868 28.0135 34.6683C28.8239 34.0775 29.7508 32.2949 30.6782 29.9936ZM40.5499 27.5493C42.7142 29.4586 44.8633 30.4748 46.1464 30.598C46.82 30.6701 47.3694 30.4271 47.6768 29.952C47.9524 29.5253 47.9723 28.9889 47.7283 28.5172C47.2781 27.6446 46.0565 27.1396 44.3774 27.1293C43.4817 27.1198 42.1192 27.2791 40.5499 27.5493ZM34.7246 22.1912C34.1105 24.225 33.4857 26.173 32.8597 27.9346C34.5097 27.4717 36.21 27.0558 37.8064 26.7155C36.6787 25.444 35.6157 23.9377 34.7246 22.1912ZM35.0135 9.50096C34.9923 9.50096 34.9718 9.50232 34.95 9.50436C34.316 9.56086 33.4639 10.5369 33.5585 12.5306C33.6556 14.5834 34.004 16.4614 34.5315 18.1651C34.8687 16.9773 35.1582 15.9271 35.385 15.1062L35.816 13.5536C36.0718 12.6497 36.1545 11.8043 36.0626 11.0399C35.9495 10.0945 35.541 9.50096 35.0135 9.50096Z"
      className={styles.fileIcon}
    />
  </svg>
);
const icon4 = (
  <svg width="73" height="83" viewBox="0 0 73 83" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M72.7956 44.9171C72.7956 42.4205 70.823 40.3887 68.3976 40.3887H66.2174V16.4166C66.2174 15.365 65.7203 14.4325 64.9554 13.8553L55.1763 3.78627C55.0805 3.6481 54.9727 3.51673 54.8551 3.39489C54.2766 2.79591 53.49 2.45898 52.6696 2.45898H15.2317C12.3792 2.45898 10.0589 4.85014 10.0589 7.78922V40.3894H7.86679C5.44202 40.3894 3.46875 42.4205 3.46875 44.9178V67.9465C3.46875 68.7892 3.79399 69.5971 4.37308 70.1927L10.0582 76.0362V76.8108C10.0582 79.7499 12.3785 82.141 15.231 82.141H61.0439C63.8964 82.141 66.2167 79.7499 66.2167 76.8108V76.0362L71.9019 70.1927C72.5583 69.5182 72.8723 68.5905 72.795 67.6716V44.9171H72.7956Z" fill="#C6C6C6"/>
<path d="M69.3269 42.4581C69.3269 39.9615 67.3543 37.9297 64.9288 37.9297H62.7486V13.9583C62.7486 12.9067 62.2515 11.9742 61.4867 11.397L51.7076 1.32728C51.6117 1.18911 51.504 1.05774 51.3863 0.935906C50.8072 0.336926 50.0206 0 49.2002 0H11.7629C8.91045 0 6.59012 2.39115 6.59012 5.33024V37.9304H4.39804C1.97261 37.9304 0 39.9615 0 42.4581V65.4869C0 66.3295 0.325242 67.1375 0.904332 67.733L6.58946 73.5765V74.3511C6.58946 77.2902 8.90979 79.6813 11.7623 79.6813H57.5752C60.4276 79.6813 62.748 77.2902 62.748 74.3511V73.5765L68.4331 67.733C69.0895 67.0585 69.4035 66.1308 69.3262 65.2119V42.4581H69.3269Z" fill="white"/>
<path d="M9.66825 72.2615L3.07812 65.4883H9.66825V72.2615Z"
       className={styles.fileIcon}

 />
<path d="M59.6641 72.2615L66.2535 65.4883H59.6641V72.2615Z"
       className={styles.fileIcon}

 />
<path d="M59.6626 14.0107H49.1484V3.18555L59.6626 14.0107Z" fill="#C6C6C6"/>
<path d="M49.2001 3.17188H11.7628C10.6079 3.17188 9.67188 4.13773 9.67188 5.32888V74.3497C9.67188 75.5409 10.6079 76.5067 11.7628 76.5067H57.5757C58.7306 76.5067 59.6667 75.5409 59.6667 74.3497V13.9569H49.1412L49.2001 3.17188Z" fill="white"/>
<path d="M66.2413 65.4874H3.07812V42.458C3.07812 41.71 3.66713 41.1035 4.39364 41.1035H64.9251C65.6516 41.1035 66.2406 41.71 66.2406 42.458V65.4874H66.2413Z" fill="#ED73AA"/>
<path d="M24.533 36.8202C23.6029 36.8202 22.8929 36.4404 22.4374 35.9047C21.4591 34.7537 21.6461 32.9248 22.8817 31.5567C23.9123 30.4166 26.9452 29.1682 30.4343 28.1016C31.3677 25.5716 32.2753 22.6625 33.0362 20.0753C32.1339 17.823 31.5224 15.2351 31.3849 12.3049C31.2553 9.55095 32.5913 7.98544 33.9782 7.86292C35.0525 7.76831 36.2668 8.56944 36.5095 10.5815C36.6238 11.5296 36.526 12.5588 36.2206 13.6404L35.7922 15.1848C35.3519 16.7775 34.9011 18.3839 34.441 19.9603C35.5146 22.4644 36.9702 24.5159 38.4979 26.1121C40.6067 25.7125 42.4438 25.4763 43.526 25.4838C46.5073 25.5008 47.6285 26.8104 48.0304 27.5898C48.4978 28.4944 48.4529 29.5759 47.9121 30.4118C47.3376 31.3014 46.3163 31.7683 45.1654 31.6567C43.5167 31.4981 40.7006 30.1511 38.0391 27.568C35.9356 27.992 33.5968 28.5679 31.4246 29.2084C30.2267 32.3374 29.0348 34.6673 27.9156 35.4834C26.5929 36.4472 25.4545 36.8202 24.533 36.8202ZM29.8188 29.7025C26.9598 30.6262 24.613 31.6302 23.8455 32.4796C22.9755 33.4421 22.9769 34.4828 23.427 35.013C23.9328 35.6073 25.2106 35.7958 27.1541 34.3773C27.9646 33.7865 28.8914 32.0038 29.8188 29.7025ZM39.6905 27.2583C41.8548 29.1675 44.0039 30.1838 45.287 30.307C45.9607 30.3791 46.51 30.1361 46.8174 29.661C47.093 29.2342 47.1129 28.6979 46.869 28.2262C46.4188 27.3536 45.1971 26.8485 43.518 26.8383C42.6223 26.8288 41.2598 26.9881 39.6905 27.2583ZM33.8652 21.9001C33.2511 23.934 32.6264 25.882 32.0003 27.6435C33.6504 27.1807 35.3506 26.7648 36.9471 26.4245C35.8193 25.153 34.7563 23.6467 33.8652 21.9001ZM34.1541 9.20994C34.1329 9.20994 34.1124 9.2113 34.0906 9.21335C33.4567 9.26984 32.6046 10.2459 32.6991 12.2396C32.7963 14.2924 33.1446 16.1704 33.6722 17.8741C34.0093 16.6863 34.2989 15.636 34.5256 14.8152L34.9566 13.2626C35.2124 12.3587 35.2951 11.5133 35.2032 10.7489C35.0901 9.80348 34.6816 9.20994 34.1541 9.20994Z" fill="#ED73AA"/>
<path d="M47.7197 50.8397C47.5044 50.443 47.1927 50.1427 46.7847 49.9387C46.388 49.7234 45.9177 49.6157 45.3737 49.6157C44.433 49.6157 43.6794 49.9274 43.1127 50.5507C42.546 51.1627 42.2627 51.9844 42.2627 53.0157C42.2627 54.115 42.5574 54.9764 43.1467 55.5997C43.7474 56.2117 44.569 56.5177 45.6117 56.5177C46.3257 56.5177 46.9264 56.3364 47.4137 55.9737C47.9124 55.611 48.275 55.0897 48.5017 54.4097H44.8127V52.2677H51.1367V54.9707C50.9214 55.696 50.553 56.3704 50.0317 56.9937C49.5217 57.617 48.87 58.1214 48.0767 58.5067C47.2834 58.892 46.388 59.0847 45.3907 59.0847C44.212 59.0847 43.158 58.8297 42.2287 58.3197C41.3107 57.7984 40.591 57.0787 40.0697 56.1607C39.5597 55.2427 39.3047 54.1944 39.3047 53.0157C39.3047 51.837 39.5597 50.7887 40.0697 49.8707C40.591 48.9414 41.3107 48.2217 42.2287 47.7117C43.1467 47.1904 44.195 46.9297 45.3737 46.9297C46.8017 46.9297 48.003 47.2754 48.9777 47.9667C49.9637 48.658 50.6154 49.6157 50.9327 50.8397H47.7197Z" fill="white"/>
<path d="M38.2842 50.9084C38.2842 51.5997 38.1255 52.2344 37.8082 52.8124C37.4909 53.3791 37.0035 53.8381 36.3462 54.1894C35.6889 54.5407 34.8729 54.7164 33.8982 54.7164H32.0962V59.0004H29.1892V47.0664H33.8982C34.8502 47.0664 35.6549 47.2307 36.3122 47.5594C36.9695 47.8881 37.4625 48.3414 37.7912 48.9194C38.1199 49.4974 38.2842 50.1604 38.2842 50.9084ZM33.6772 52.4044C34.2325 52.4044 34.6462 52.2741 34.9182 52.0134C35.1902 51.7527 35.3262 51.3844 35.3262 50.9084C35.3262 50.4324 35.1902 50.0641 34.9182 49.8034C34.6462 49.5427 34.2325 49.4124 33.6772 49.4124H32.0962V52.4044H33.6772Z" fill="white"/>
<path d="M26.8411 47.0664V55.1924C26.8411 56.4504 26.4841 57.4194 25.7701 58.0994C25.0675 58.7794 24.1155 59.1194 22.9141 59.1194C21.6561 59.1194 20.6475 58.7624 19.8881 58.0484C19.1288 57.3344 18.7491 56.3201 18.7491 55.0054H21.6391C21.6391 55.5041 21.7411 55.8837 21.9451 56.1444C22.1491 56.3937 22.4438 56.5184 22.8291 56.5184C23.1805 56.5184 23.4525 56.4051 23.6451 56.1784C23.8378 55.9517 23.9341 55.6231 23.9341 55.1924V47.0664H26.8411Z" fill="white"/>
</svg>

)

const data = [
  {
    type: "Pdf",
    name: "weddingcalander.PDF",
  },
  {
    type: "Doc",
    name: "weddingcalander.DOC",
  },
  {
    type: "Png",
    name: "weddingcalander.PNG",
  },
  {
    type: "Pdf",
    name: "weddingcalander.PDF",
  },
  {
    type: "Doc",
    name: "weddingcalander.DOC",
  },
  {
    type: "Png",
    name: "weddingcalander.PNG",
  },
  {
    type: "Pdf",
    name: "weddingcalander.PDF",
  },
  {
    type: "Doc",
    name: "weddingcalander.DOC",
  },
  {
    type: "Png",
    name: "weddingcalander.PNG",
  },
  {
    type: "Pdf",
    name: "weddingcalander.PDF",
  },
  {
    type: "Doc",
    name: "weddingcalander.DOC",
  },
  {
    type: "Png",
    name: "weddingcalander.PNG",
  },
];
const renderDocumentList = ((item)=>{
  let locateName = item?.doc?.split("/");
  let docName = locateName[locateName?.length - 1];
  
  console.log('itemmmm', item);
  return(
   
    <a className={styles.docCont} href={item?.doc} target="_blank" >
      {docName?.includes("doc")
        ? icon1
        : docName?.includes("png")
        ? icon2
        : docName?.includes("pdf") ? icon3 : icon4}
    </a>
  )
})

function Documents({ details }) {
  return (
    <>
      <TextComponent text={"Documents"} textClass={styles.documentsHeading} />
      <List
       grid={{ }}
      itemLayout="horizontal"
        dataSource={details?.documents}
        className={styles.documentContainer}
        renderItem={renderDocumentList}
      />
      {/* <Row className={styles.documentContainer}>
        
        {details?.documents?.map((item) => (
          <Col className={styles.docCont} onClick={item?.doc}>
         
            {item.doc?.includes("doc") ? icon1 :
            item.doc?.includes("png") ? icon2 :
            item.doc?.includes("pdf") && icon3}
          </Col>
        ))}
      </Row> */}
    </>
  );
}

export default Documents;
